import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IconButtonModule } from '@shared/layout/components/icon-button/icon-button.module';
import { TableFilteringComponent } from './table-filtering/table-filtering.component';

@NgModule({
    declarations: [TableFilteringComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        IconButtonModule,
    ],
    exports: [TableFilteringComponent],
})
export class TableModule {}
